import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle(event) {
    const button = event.currentTarget
    const content = button.nextElementSibling
    const icon = button.querySelector("svg")

    if (content.classList.contains("hidden")) {
      content.classList.remove("hidden")
      icon.classList.add("rotate-180")
    } else {
      content.classList.add("hidden")
      icon.classList.remove("rotate-180")
    }
  }
}
